/*
 * Copyright Innov'ATM all rights reserved.
 * This software is the property of Innov'ATM and may not be used in any manner except under a
 * license agreement signed with Innov'ATM.
 */

import { createMockReactOidc } from 'oidc-spa/mock/react';
import { createReactOidc } from 'oidc-spa/react';

export const mockedTokens = {
    accessToken: 'storybook-mock-access-token',
    idToken: 'storybook-mock-id-token',
    refreshToken: 'storybook-mock-refresh-token',
};

// In Vite, BASE_URL defaults to '/' but we need empty string for root deployments
const baseUrl = import.meta.env.BASE_URL === '/' ? '' : import.meta.env.BASE_URL;

// Check if we're in Storybook mode
// In Vite: use import.meta.env, in Storybook/webpack: use process.env
const isStorybook =
    (typeof process !== 'undefined' && process.env?.STORYBOOK) ||
    import.meta.env.MODE === 'storybook' ||
    import.meta.env.VITE_STORYBOOK === 'true';

export const { OidcProvider, useOidc, getOidc } = isStorybook
    ? createMockReactOidc({
          isUserInitiallyLoggedIn: true,
          homeUrl: baseUrl,
          mockedTokens: mockedTokens,
          autoLogin: true,
      })
    : createReactOidc({
          issuerUri: import.meta.env.VITE_OIDC_ISSUER || '',
          clientId: import.meta.env.VITE_OIDC_CLIENT_ID || '',
          homeUrl: baseUrl,
          autoLogoutParams: { redirectTo: 'home' },
          autoLogin: true,
      });
